module.exports = __webpack_public_path__ + "img/23.c484379b.png";